import * as React from 'react'

import { Collapsible as CollapsibleElement } from '@espoon-voltti/react-components/layout'
import { IconDefinition } from '@fortawesome/pro-light-svg-icons'

interface Props {
  title: string
  dataQa?: string
  icon: IconDefinition
  children: React.ReactNode
  open?: boolean
}

export const Collapsible = ({ open = true, children, ...props }: Props) => {
  const [isOpen, setOpen] = React.useState(open)
  const handleToggle = () => setOpen(!isOpen)
  return (
    <CollapsibleElement {...props} onToggle={handleToggle} open={isOpen}>
      {children}
    </CollapsibleElement>
  )
}
